var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M3133.036,5934.822h3.893a1.175,1.175,0,0,0,1.058-.665l.536-1.111a6.4,6.4,0,0,1,5.762-3.62h.343a7.828,7.828,0,0,0,4.974-1.784l1.3-1.071a6.31,6.31,0,0,0,1.842-2.51l.415-1.025a1.26,1.26,0,0,1,1.167-.788h0a1.26,1.26,0,0,1,1.26,1.26v1.664a7.416,7.416,0,0,1-2.53,5.579h0",
    transform: "translate(-3124.833 -5914.17)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M3145.547,5932.3h13.9a2.179,2.179,0,0,1,2.178,2.179h0a2.177,2.177,0,0,1-2.178,2.178H3152",
    transform: "translate(-3124.833 -5914.17)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M3152,5936.654h6.842a2.179,2.179,0,0,1,2.178,2.179h0a2.178,2.178,0,0,1-2.178,2.178H3152",
    transform: "translate(-3124.833 -5914.17)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M3152,5941.011h6.235a2.179,2.179,0,0,1,2.179,2.179h0a2.178,2.178,0,0,1-2.179,2.178H3152",
    transform: "translate(-3124.833 -5914.17)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M3152,5945.368h3.3a2.179,2.179,0,0,1,2.178,2.179h0a2.178,2.178,0,0,1-2.178,2.178h-12.369l-6.254-2.881h-3.647",
    transform: "translate(-3124.833 -5914.17)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/iconSuccess.c661c72a783485350932fee4e7f90fa4.svg";
export { ForwardRef as ReactComponent };